
import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FunctionService} from 'vhobjects-service/src/services';
@Component({
  selector: 'atw-select-address-config',
  templateUrl: './select-address-config.component.html',
  styleUrls: ['./select-address-config.component.scss'],
})
export class AtwSelectAddressConfig implements OnInit {
  isCollapsed: boolean = false;
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  dataAfterChange: any = {}; // lưu tên và style data để cập nhật vào database.
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;
  fonts = []

  backgroundColor: any = [];
  dataBorder = [
    {
      name: 'solid',
      img_border: 'https://static.thenounproject.com/png/2264019-200.png',
    },
    {
      name: 'dashed',
      img_border: 'https://static.thenounproject.com/png/2264023-200.png',
    },
    {
      name: 'dotted',
      img_border: 'https://static.thenounproject.com/png/2449182-200.png',
    },
  ];
  styles_field = [
    {
      title: 'Điều chỉnh nội dung',
      index: 1,
    },
    {
      title: 'Điều chỉnh viền',
      index: 2,
    },
    {
      title: 'Hiệu ứng chuyển động',
      index: 3,
    },
    {
      title: 'Nâng cao',
      index: 4,
    },
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
  ) { }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([fonts]: any) => {
      this.fonts = fonts;
    })
  }

  /**
  * Hàm này dùng để cho phép mở menu config .
  * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
  * @param: value
  */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
  * Hàm update object vào database.
  */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
 *Hàm update class vào database.
 */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
 * Cập nhật staticdata vào database.
 */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        
      });
  }



}
